import React from 'react';
import { useIcon } from '../../Hooks/useIcon';
export type PyramidField = {
  icon: string;
  iconColor: string;
  title: string;
  titleColor: string;
  sectionBackground: string;
  description: string;
  documentLinkIcon: string;
  documentLinkTitle: string;
};

const SECTION_HEIGHT = 130;
const BASE_WIDTH = 145;

const Pyramid: React.FC<{
  fields: PyramidField[];
}> = ({ fields = [] }) => {
  return (
    <div
      className="pyramid-container"
      style={{ width: '100%', position: 'relative' }}
    >
      <div
        className="lines"
        style={{ position: 'absolute', width: '100%', top: 0 }}
      >
        {fields.map((field, index) => {
          return (
            <div
              key={new Date().getTime() + index + ''}
              className="line"
              style={{
                borderBottom: '2px solid #222',
                height: SECTION_HEIGHT,
                marginLeft:
                  (BASE_WIDTH * fields.length) / 2 +
                  (BASE_WIDTH * (index + 1)) / 2 -
                  2 +
                  'px',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  right: 20,
                  bottom: 15,
                  fontSize: 14,
                  textAlign: 'justify',
                  lineHeight: '18px',
                }}
              >
                {field.description ? field.description : 'Description'}
              </div>
              <div
                className="small-circle"
                style={{
                  position: 'absolute',
                  backgroundColor: '#222',
                  borderRadius: '50%',
                  right: 0,
                  bottom: -5,
                  width: 8,
                  height: 8,
                }}
              ></div>
            </div>
          );
        })}
      </div>
      <div
        className="pyramid"
        style={{
          width: BASE_WIDTH * fields.length + 'px',
          height: SECTION_HEIGHT * fields.length + 'px',
          display: 'flex',
          flexDirection: 'column',
          clipPath: 'polygon(50% 0, 100% 100%, 0 100%)',
        }}
      >
        {fields.map((field, index) => {
          return (
            <div
              key={`pyramid-section${index}`}
              className="pyramid-section"
              style={{
                flex: '1 1 100%',
                backgroundColor: field.sectionBackground,
                marginBottom: '1px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <div
                className="pyramid-section-content"
                style={{
                  display: 'flex',
                  flexDirection: index === 0 ? 'column' : 'row',
                  marginBottom: index === 0 ? -25 : -40,
                  alignItems: 'center',
                  fontSize: 50,
                }}
              >
                <div
                  data-href={field.documentLinkIcon}
                  style={{
                    position: index === 0 ? 'initial' : 'absolute',
                    left:
                      index === 0 ? '0' : (BASE_WIDTH * fields.length) / 2 - 90,
                    cursor: field.documentLinkIcon ? 'pointer' : 'initial',
                  }}
                >
                  <PyramidIcon color={field.iconColor} iconName={field.icon} />
                </div>
                <div
                  className="pyramid-section-title"
                  data-href={field.documentLinkTitle}
                  style={{
                    fontSize: 20,
                    color: field.titleColor,
                    marginTop: index === 0 ? -9 : -12,
                    marginLeft: index === 0 ? 0 : 0,
                    cursor: field.documentLinkTitle ? 'pointer' : 'initial',
                  }}
                >
                  {field.title ? field.title : 'Title'}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Pyramid;

function PyramidIcon(props: any) {
  const Icon = useIcon(props);
  return Icon;
}
